import { render, staticRenderFns } from "./formdialog.vue?vue&type=template&id=f8c6b3f2&"
import script from "./formdialog.vue?vue&type=script&lang=js&"
export * from "./formdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports